module.exports = __webpack_public_path__ + "img/total-energies.b4e91fe3.png";